import localforage from 'localforage';

const API_BASE_URL = process.env.REACT_APP_GRAPHQL_SERVER_BASE_URL || 'http://localhost';

const authHeaders = async () => {
  const token = await localforage.getItem('otx_a');
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  };
};

/**
 * Valida un cupón para un plan: POST /api/coupons/validate { code, plan_id }.
 * @param {string} code
 * @param {number|string} planId
 * @returns {Promise<{valid:boolean, discount_value?:number, discounted_price?:number, currency?:string, coupon_id?:number, reason?:string}>}
 */
const validateCoupon = async (code, planId) => {
  const response = await fetch(`${API_BASE_URL}/api/coupons/validate`, {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ code, plan_id: planId })
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    return { valid: false, reason: data.error || data.message || 'Error' };
  }
  return response.json();
};

export default { validateCoupon };
